import React, { useCallback, useEffect, useState } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import HeadContainer from '../../../common/head-container';
import ReCAPTCHA from 'react-google-recaptcha';

const WelcomeFormScreen = ({
  telegramLink,
  setScreenNumber,
  handleNextScreen,
  handleSkipScreen,
  isHideSkipButton = false
}) => {
  const [captchaPassed, setCaptchaPassed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  const handleCaptchaChange = useCallback((token) => {
    setCaptchaPassed(!!token);
  }, []);

  const handleCaptchaExpired = useCallback(() => {
    setCaptchaPassed(false);
  }, []);

  useEffect(() => {
    try {
      const mq = window.matchMedia('(max-width: 480px)');
      const update = () => setIsMobile(mq.matches);
      update();
      if (mq.addEventListener) {
        mq.addEventListener('change', update);
      } else if (mq.addListener) {
        mq.addListener(update);
      }
      return () => {
        if (mq.removeEventListener) {
          mq.removeEventListener('change', update);
        } else if (mq.removeListener) {
          mq.removeListener(update);
        }
      };
    } catch (e) {
      setIsMobile(false);
    }
  }, []);

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <div className={styles.headContainer}>
        <HeadContainer
          setScreenNumber={setScreenNumber}
          telegramOnly
          customTelegramLink={telegramLink}
        />
      </div>
      <div className={styles.content}>
        <p className={styles.title}>
          Вітаємо у діджитальному<br></br>
          світі компанії Філіп<br></br>Морріс!
        </p>
        <p className={styles.description}>
          Реєструйся на платформі, проходь коротке<br></br>
          опитування та отримуй поповнення<br></br>
          мобільного рахунку на 30 гривень за<br></br>
          витрачений час.
        </p>
        <div className={styles.buttonContainer}>
          {siteKey && (
            <div style={{ marginBottom: 16, width: '100%' }}>
              <ReCAPTCHA
                sitekey={siteKey}
                size="normal"
                onChange={handleCaptchaChange}
                onExpired={handleCaptchaExpired}
              />
            </div>
          )}
          <button
            className={styles.nextButton}
            onClick={handleNextScreen}
            disabled={siteKey ? !captchaPassed : false}
          >
            Далі
          </button>
          {!isHideSkipButton && (
            <button className={styles.skipButton} onClick={handleSkipScreen}>
              Пропустити
            </button>
          )}
        </div>
      </div>
      <div className={styles.footer}>
        Натискаючи «ДалI» ти робиш запит на отримання інформації про продукцію
        компанії Філіп Морріс засобами дистанційного зв'язку відповідно до
        частини 2 статті 15 Закону «Про захист пра в споживачів» та
        підтверджуєш, що Є СПОЖИВАЧЕМ ТЮТЮНОВИХ ВИРОБІВ ТА/АБО КОРИСТУВАЧЕМ
        ПРИСТРОЇВ ДЛЯ СПОЖИВАННЯ ТЮТЮНОВИХ ВИРОБІВ БЕЗ ЇХ ЗГОРЯННЯ“.
      </div>
    </div>
  );
};

export default WelcomeFormScreen;
